import auth from '../middleware/auth';
import ChildRoutes from './ChildRoutes';
import MagTemplateLayout from '../../views/layouts/MagTemplateLayout';

export default {
	path: 'mag-templates',
	component: MagTemplateLayout,
	children: ChildRoutes,
	meta: {
		middleware: {
			auth
		}
	}
};
